import { SHOW_LOGIN_POPUP, HIDE_LOGIN_POPUP } from '../../constant';
export const hideLoginPopup = () => ({
  type: HIDE_LOGIN_POPUP,
});

export const showLoginPopup = () => ({
  type: SHOW_LOGIN_POPUP,
});
